export enum EFunnelStep {
  NONE = 'STEP_NONE',
  RESULTS = 'STEP_RESULTS',
  PAYMENT = 'STEP_PAYMENT',
  INFO = 'STEP_PASSENGERS_INFO',
}

export interface IAppContext {
  partner: PartnerWithConfiguration | null;
  funnelStep: EFunnelStep;
  isInFunnel: boolean;
  referer: string;
  isLoading?: boolean;
  setRefererId: (refererId: string) => boolean;
}

export interface IPartner {
  id: string;
  gpuids?: string[];
  placeholder?: string;
  header?: string;
  subHeader?: string;
  primaryColor?: string;
  secondaryColor?: string;
  backgroundUrl?: string;
  logoUrl?: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export type PartnerWithConfiguration = IPartner & {
  configuration: PartnerConfiguration;
};

export type PartnerConfiguration = {
  hideFooter: boolean;
};
